// extracted by mini-css-extract-plugin
module.exports = {"label":"undefined","unit":"var(--ring-unit)","inputContainer":"BranchInput__inputContainer--hz","popup":"BranchInput__popup--uP"};